<header class="app-header">
    <div class="header-left">
        <i class="fa-solid fa-bars mobile-menu-icon" (click)="sidenav.toggle()"></i>

        <div class="logo">
            <img src="/assets/img/she-leaps-woman-logo.png" alt="SHE-LEAPS Logo" />
            <div class="brand-block">
                <span class="brand-text">
                    <span class="highlight">SHE-LEAPS</span>
                </span>
                <span class="brand-tagline">Self Help Entrepreneurs: Livelihoods and Enterprise Applications for Prosperity & Sustainability</span>
            </div>
        </div>
    </div>

    <div class="header-right">
        <div class="user-trigger" (click)="togglePopOver()">
            <!-- AVATAR WITH STATUS -->
            <div class="avatar-wrapper">
                <img class="avatar" [src]="userDetails().imageData || '/assets/img/avatar-logo.svg'" />

                <!-- status dot -->
                <span class="status-dot" [class.online]="isOnline" [class.offline]="!isOnline"></span>
            </div>

            <div class="user-text">
                <div class="name">{{ userDetails().userFullName }}</div>
                <div class="role">{{ activeRoleDisplayNameClean() }}</div>
            </div>

            <img src="/assets/img/caret-down.svg" alt="caret-down" />
        </div>

        <!-- POPOVER -->
        @if (showPopOver) {
            <div class="popover" (click)="$event.stopPropagation()">
                <div class="roles-section">
                    <mat-accordion>
                        <mat-expansion-panel #panel expanded>
                            <!-- HEADER -->
                            <mat-expansion-panel-header class="roles-header">
                                <div class="header-left">
                                    <img src="/assets/img/user-roles.svg" class="icon" alt="user-role" />
                                    <span class="title">{{ "yourRoles" | translate }}</span>
                                </div>
                            </mat-expansion-panel-header>

                            <!-- BODY -->
                            <div class="role-list">
                                @for (role of userDetails().roles; track role) {
                                    <div
                                        class="role-item"
                                        [class.active]="role.roleDisplayName === activeRoleDisplayName()"
                                        (click)="changeRole(role)"
                                    >
                                        {{ role.roleDisplayName }}
                                    </div>
                                }
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div class="logout-section" (click)="signOutUser()">
                    <img src="/assets/img/logout.svg" class="icon" alt="logout" />
                    <span>{{ "signOut" | translate }}</span>
                </div>
            </div>
        }
    </div>
</header>
